import styles from "./DensityPlot.module.css";
import PlotWrapper from "../components/PlotWrapper";
import { HISTOGRAM_CONFIG } from "../constants";
import React from "react";
import { TRootState } from "../store/create-store";
import { useSelector } from "react-redux";
import { Figure } from "react-plotly.js";
import classNames from "classnames";
import { selectRightPanelState, selectRootState } from "../selectors";

const layout: Figure["layout"] = {
  autosize: true,
  width: 200,
  height: 200,
  hovermode: "closest" as const,
  xaxis: {
    title: "x",
  },
  yaxis: {
    title: "y",
  },
  paper_bgcolor: "white",
  plot_bgcolor: "white",
  margin: {
    l: 0,
    r: 0,
    b: 0,
    t: 0,
  },
};

const DensityPlot = () => {
  const { densityPlotData, showDensityPlot } = useSelector(selectDensityPlot);

  if (!densityPlotData || !showDensityPlot) {
    return null;
  }

  return (
    <div className={classNames(styles.wrapper)}>
      <PlotWrapper
        key="density"
        data={densityPlotData}
        layout={layout}
        config={HISTOGRAM_CONFIG}
        onClick={() => {}}
        onRelayout={() => {}}
      />
    </div>
  );
};

const selectDensityPlot = (state: TRootState) => {
  const { densityPlotData } = selectRootState(state);
  const rightPanel = selectRightPanelState(state);

  return {
    densityPlotData: densityPlotData,
    rightPanelVisible: rightPanel.visible,
    showDensityPlot: rightPanel.showDensityPlot,
  };
};

export default DensityPlot;
